import { render, staticRenderFns } from "./AssignTool.vue?vue&type=template&id=0b4e5b68&"
import script from "./AssignTool.vue?vue&type=script&lang=js&"
export * from "./AssignTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports